import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./dental.css";
import DentalOffer from "./DentalOffer";

import chayadoc from "./../../../assets/images/Doctorsimages/dr.Chayanika.png"
import yuvapriya from "./../../../assets/images/Doctorsimages/dr.yuvapriya.png"
import drHelenaImg from "../../../assets/images/chainikadental.jpg";
import beforeafter1 from "../../../assets/images/dentalimages/6.png";
import beforeafter2 from "../../../assets/images/dentalimages/7.png";
import beforeafter3 from "../../../assets/images/dentalimages/8.png";
import beforeafter4 from "../../../assets/images/dentalimages/9.png";
import beforeafter5 from "../../../assets/images/dentalimages/10.png";
import beforeafter6 from "../../../assets/images/dentalimages/11.png";
import beforeafter7 from "../../../assets/images/dentalimages/12.png";
import beforeafter8 from "../../../assets/images/dentalimages/13.png";
import beforeafter9 from "../../../assets/images/dentalimages/14.png";
import beforeafter10 from "../../../assets/images/dentalimages/15.jpg";
import beforeafter11 from "../../../assets/images/dentalimages/16.jpg";
import beforeafter12 from "../../../assets/images/dentalimages/17.jpg";
import beforeafter13 from "../../../assets/images/dentalimages/18.jpg";
import GeneralDentistry from "../../../assets/images/dentalimages/GeneralDentistry.jpg";
import Scaling from "../../../assets/images/dentalimages/Scaling.jpg";  
import GICFilling from "../../../assets/images/dentalimages/GIC-Filling.jpg";
import CompositeFilling from "../../../assets/images/dentalimages/composite-filling.jpg";
import Endodontics from "../../../assets/images/dentalimages/Endodontics.jpg";
import rootcanaltreatment from "../../../assets/images/dentalimages/rootcanaltreatment.jpg";
import laserrct from "../../../assets/images/dentalimages/laser-rct.jpg";
import rerct from "../../../assets/images/dentalimages/re-rct.jpg";
import Prosthodontics from "../../../assets/images/dentalimages/Prosthodontics.jpg";
import crowns from "../../../assets/images/dentalimages/crowns.jpg";
import Periodontics from "../../../assets/images/dentalimages/Periodontics.jpg";
import OralMaxillofacialSurgery from "../../../assets/images/dentalimages/OralMaxillofacialSurgery.jpg";
import PediatricDentistry from "../../../assets/images/dentalimages/PediatricDentistry.jpg";
import Orthodontics from "../../../assets/images/dentalimages/Orthodontics.jpeg";
import DentalImplants from "../../../assets/images/dentalimages/DentalImplants.jpg";
import axios from 'axios';
import { API_CONFIG } from '../../../utils/config'; 

const Dental = () => {
  const [activeTab, setActiveTab] = useState("all");
  const [isScrolled, setIsScrolled] = useState(false);
  const [isAnimating, setIsAnimating] = useState({});
  const [activeTestimonial, setActiveTestimonial] = useState(0);
  const [activeGalleryItem, setActiveGalleryItem] = useState(0);
  const [expandedCategory, setExpandedCategory] = useState(null);

  // Form state
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    service: "", 
    message: ""
  });
  const [formSubmitting, setFormSubmitting] = useState(false);
  const [formSuccess, setFormSuccess] = useState(false);
  const [formError, setFormError] = useState("");

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  // Handle form submission with improved error handling
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitting(true);
    setFormError("");
    
    try {
      console.log("Submitting form data:", formData);
      
      const apiUrl = `${API_CONFIG.baseURL7001}${API_CONFIG.apiPath}${API_CONFIG.apiName.apptFormFilling}`;
      console.log("API URL:", apiUrl);
      
      const response = await axios.post(apiUrl, {
        name: formData.name,
        emailId: formData.email,
        phoneNo: formData.phone,
        concern: formData.service, 
        message: formData.message
      });
      
      console.log("API Success Response:", response.data);
      
      setFormSuccess(true);
      setFormData({
        name: "",
        email: "",
        phone: "",
        service: "",
        message: ""
      });
      
      setTimeout(() => {
        setFormSuccess(false);
      }, 5000);
      
    } catch (error) {
      console.error("Form submission error:", error);
      if (error.response) {
        console.error("Response data:", error.response.data);
        console.error("Response status:", error.response.status);
      }
      setFormError("There was an error submitting your appointment request. Please try again.");
    } finally {
      setFormSubmitting(false);
    }
  };

  // Ref for horizontal scroll container
  const testimonialScrollRef = useRef(null);
  const navigate = useNavigate(); 

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);

      document.querySelectorAll(".animate-on-scroll").forEach((element) => {
        const rect = element.getBoundingClientRect();
        const isInViewport =
          rect.top <=
            (window.innerHeight || document.documentElement.clientHeight) *
              0.8 && rect.bottom >= 0;

        if (isInViewport) {
          setIsAnimating((prev) => ({ ...prev, [element.id]: true }));
        }
      });
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Auto-scroll gallery functionality
  useEffect(() => {
    const galleryInterval = setInterval(() => {
      setActiveGalleryItem((prevIndex) =>
        prevIndex === galleryItems.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000); 

    return () => clearInterval(galleryInterval);
  }, []);

  // Auto-scroll testimonials functionality (for carousel, not for horizontal scroll)
  useEffect(() => {
    const testimonialInterval = setInterval(() => {
      setActiveTestimonial((prevIndex) =>
        prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000); 

    return () => clearInterval(testimonialInterval);
  }, []);

  // Add this useEffect after your existing useEffect hooks (around line 200-250)
useEffect(() => {
  document.title = "Best Dental Clinic in India | H-Cura Dental Care & Treatments";
  const metaDescription = document.querySelector("meta[name='description']");
  if (metaDescription) {
    metaDescription.setAttribute(
      "content",
      "Get expert dental care at H-Cura Multispeciality Clinic. Services include teeth whitening, dental implants, orthodontics, and painless treatments. Available in Bangalore, Chennai & more. Book your appointment today!"
    );
  }
  const metaKeywords = document.querySelector("meta[name='keywords']");
  if (metaKeywords) {
    metaKeywords.setAttribute(
      "content",
      "Dental clinic India, Best dentist India, Dental implants India, Teeth whitening India, Orthodontics India, Painless dental treatment India, Cosmetic dentistry India, Root canal treatment India, Oral health India, Dental care clinic India, Pediatric dentist India, Dental braces India, Dental treatment Chennai, Dental treatment Bangalore, Dental treatment Valasaravakkam, Dental treatment Tambaram, Dental treatment Gerugambakkam, Dental treatment Jayanagar, Dental care H-Cura"
    );
  }
  // Set canonical link
  const existingCanonical = document.querySelector("link[rel='canonical']");
  if (existingCanonical) {
    existingCanonical.setAttribute("href", "https://www.h-cura.com/dental-treatment");
  } else {
    const canonicalLink = document.createElement("link");
    canonicalLink.setAttribute("rel", "canonical");
    canonicalLink.setAttribute("href", "https://www.h-cura.com/dental-treatment");
    document.head.appendChild(canonicalLink);
  }
  // Set favicon
  
}, []);

// Handler for category clicks - Updated to include scrolling
const handleCategoryClick = (categoryId) => {
  setExpandedCategory(categoryId);
  
  // Scroll to treatments section after a brief delay to allow state update
  setTimeout(() => {
    const treatmentsSection = document.getElementById('treatments');
    if (treatmentsSection) {
      treatmentsSection.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start' 
      });
    }
  }, 100);
};

// Handler for tab clicks - Updated to include scrolling
const handleTabClick = (tabId) => {
  setActiveTab(tabId);
  setExpandedCategory(null);
  
  // Scroll to treatments section for non-"all" tabs
  if (tabId !== "all") {
    setTimeout(() => {
      const treatmentsSection = document.getElementById('treatments');
      if (treatmentsSection) {
        treatmentsSection.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'start' 
        });
      }
    }, 100);
  }
};


  // Handler for testimonial navigation
  const goToTestimonial = (index) => {
    setActiveTestimonial(index);
  };

  // Testimonial quotes for the strip (same as Chennai design)
  const testimonialQuotes = [
    "H-Cura Dental combines the best modern dentistry with compassionate care.",
    "The expertise and technology at H-Cura Dental is unmatched in the industry.",
    "From consultation to recovery, H-Cura Dental provides world-class dental care."
  ];

  const galleryItems = [
    {
      id: 1,
      treatment: "Filling",
      image: beforeafter1,
    },
    {
      id: 2,
      treatment: "Filling",
      image: beforeafter2,
    },
    {
      id: 3,
      treatment: "Filling",
      image: beforeafter3,
    },
    {
      id: 4,
      treatment: "Filling",
      image: beforeafter4,
    },
    {
      id: 5,
      treatment: "Filling",
      image: beforeafter5,
    },
    {
      id: 6,
      treatment: "Scaling",
      image: beforeafter6,
    },
    {
      id: 7,
      treatment: "Scaling",
      image: beforeafter7,
    },
    {
      id: 8,
      treatment: "Scaling",
      image: beforeafter8,
    },
    {
      id: 9,
      treatment: "Scaling",
      image: beforeafter9,
    },
    {
      id: 10,
      treatment: "Scaling",
      image: beforeafter10,
    },
    {
      id: 11,
      treatment: "Scaling",
      image: beforeafter11,
    },
    {
      id: 12,
      image: beforeafter12,
      treatment: "Grafting",
    },
     {
      id: 13,
      treatment: "Scaling",
      image: beforeafter13,
    },
  ];

  // Advanced treatments with categories
  const treatments = [
    {
      id: 1,
      title: "General Dentistry",
      description:
        "Preview your smile transformation with our 3D imaging technology before treatment begins.",
      image: GeneralDentistry,
      category: "cosmetic",
    },
    {
      id: 2,
      title: "Endodontics",
      description:
        "Custom clear aligners that straighten teeth discreetly without the need for metal braces.",
      image:
        "https://images.unsplash.com/photo-1598256989800-fe5f95da9787?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MXxzZWFyY2h8Nnx8ZGVudGlzdHxlbnwwfHx8fDE3NDI0NDc1MjR8MA&auto=format&fit=crop&w=600&q=60",
      category: "orthodontic",
      icon: "https://img.icons8.com/fluency/96/retainer.png",
    },
    {
      id: 3,
      title: "Prosthodontics",
      description:
        "Precision treatments with minimal discomfort using state-of-the-art dental lasers.",
      image:
        "https://images.unsplash.com/photo-1616391182219-e080b4d1043a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MXxzZWFyY2h8Nnx8ZGVudGlzdCUyMGNsaW5pY3xlbnwwfHx8fDE3NDI1NDM3NDN8MA&auto=format&fit=crop&w=600&q=60",
      category: "advanced",
      icon: "https://img.icons8.com/fluency/96/laser-beam.png",
    },
    {
      id: 4,
      title: "Periodontics",
      description:
        "Ultra-thin porcelain shells that transform teeth with imperfections into a flawless smile.",
      image:
        "https://images.unsplash.com/photo-1609840114035-3c981b782dfe?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MXxzZWFyY2h8Nnx8ZGVudGFsJTIwc21pbGV8ZW58MHx8fHwxNzQyNTAwMTE4fDA&auto=format&fit=crop&w=600&q=60",
      category: "cosmetic",
      icon: "https://img.icons8.com/fluency/96/tooth-cleaning.png",
    },
    {
      id: 5,
      title: "OMFS",
      description:
        "Custom-designed titanium implants created with precision 3D printing technology.",
      image:
        "https://images.unsplash.com/photo-1468493858157-0da44aaf1d13?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MXxzZWFyY2h8Nnx8ZGVudGFsJTIwaW1wbGFudHxlbnwwfHx8fDE3NDI1NDk0NjB8MA&auto=format&fit=crop&w=600&q=60",
      category: "restorative",
      icon: "https://img.icons8.com/fluency/96/tooth-drill.png",
    },
    {
      id: 6,
      title: "Pediatric Dentistry",
      description:
        "Early detection of dental issues using artificial intelligence and machine learning.",
      image:
        "https://images.unsplash.com/photo-1588776814601-a454a8e3a940?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MXxzZWFyY2h8Nnx8ZGVudGFsJTIwdHJlYXRtZW50fGVufDB8fHx8MTc0MjQ4MTAwNHww&auto=format&fit=crop&w=600&q=60",
      category: "advanced",
      icon: "https://img.icons8.com/fluency/96/artificial-intelligence.png",
    },
    {
      id: 7,
      title: "Orthodontics",
      description:
        "Laser-assisted gum contouring to create a more balanced and aesthetic smile line.",
      image:
        "https://images.unsplash.com/photo-1600170311833-c2cf5280ce49?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MXxzZWFyY2h8Nnx8ZGVudGFsJTIwc3VyZ2VyeXxlbnwwfHx8fDE3NDI1Mjk5OTd8MA&auto=format&fit=crop&w=600&q=60",
      category: "cosmetic",
      icon: "https://img.icons8.com/fluency/96/gums.png",
    },
    {
      id: 8,
      title: "Implantology",
      description:
        "Conservative treatments that preserve natural tooth structure while restoring function.",
      image:
        "https://images.unsplash.com/photo-1606811856475-5e6fcdc6e509?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MXxzZWFyY2h8Nnx8ZGVudGFsJTIwY2xpbmljfGVufDB8fHx8MTc0MjU0MDAwMHww&auto=format&fit=crop&w=600&q=60",
      category: "restorative",
      icon: "https://img.icons8.com/fluency/96/tooth.png",
    },
    {
      id: 9,
      title: "Sleep Apnea Therapy",
      description:
        "Custom oral appliances to treat sleep apnea and improve quality of sleep and health.",
      image:
        "https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MXxzZWFyY2h8Nnx8ZGVudGFsJTIwb2ZmaWNlfGVufDB8fHx8MTc0MjQ4MTc5OXww&auto=format&fit=crop&w=600&q=60",
      category: "specialized",
      icon: "https://img.icons8.com/fluency/96/sleeping.png",
    },
  ];

  const filteredTreatments =
    activeTab === "all"
      ? treatments
      : treatments.filter((treatment) => treatment.category === activeTab);

  const categories = [
    {
      id: "general",
      name: "General Dentistry",
      icon: "https://img.icons8.com/fluency/96/tooth.png",
      image: GeneralDentistry,
      description: "Comprehensive dental care for patients of all ages",
      treatments: [
        {
          id: "scaling",
          title: "Scaling",
          description:
            "Professional cleaning to remove plaque and tartar buildup",
          image: Scaling,
          icon: "https://img.icons8.com/fluency/96/tooth.png",
        },
        {
          id: "gic-filling",
          title: "GIC Filling",
          description:
            "Glass Ionomer Cement fillings for restoring damaged teeth",
          image: GICFilling,
          icon: "https://img.icons8.com/fluency/96/tooth.png",
        },
        {
          id: "composite-filling",
          title: "Composite Filling",
          description:
            "Tooth-colored fillings that blend seamlessly with your natural teeth",
          image: CompositeFilling,
          icon: "https://img.icons8.com/fluency/96/tooth.png",
        },
      ],
    },
    {
      id: "endodontics",
      name: "Endodontics",
      icon: "https://img.icons8.com/fluency/96/tooth.png",
      image: Endodontics,
      description:
        "Specialized treatments for the dental pulp and root canal system",
      treatments: [
        {
          id: "rct",
          title: "Root Canal Treatment (RCT)",
          description:
            "Procedure to remove infected pulp and save the natural tooth",
          image: rootcanaltreatment,
          icon: "https://img.icons8.com/fluency/96/tooth.png",
        },
        {
          id: "laser-rct",
          title: "Laser RCT",
          description:
            "Advanced root canal treatment using laser technology for precision",
          image: laserrct,
          icon: "https://img.icons8.com/fluency/96/tooth.png",
        },
        {
          id: "re-rct",
          title: "Re-RCT",
          description:
            "Retreatment of previously treated root canals that have failed",
          image: rerct,
          icon: "https://img.icons8.com/fluency/96/tooth.png",
        },
      ],
    },
    {
      id: "prostho",
      name: "Prosthodontics",
      icon: "https://img.icons8.com/fluency/96/tooth.png",
      image: Prosthodontics,
      description:
        "Dental prostheses to replace missing teeth and restore function",
      treatments: [
        {
          id: "crowns",
          title: "Crowns",
          description:
            "Custom-made caps that cover damaged teeth to restore shape and function",
          image: crowns,
          icon: "https://img.icons8.com/fluency/96/tooth.png",
        },
        {
          id: "bridges",
          title: "Bridges",
          description:
            "Fixed dental prostheses to replace one or more missing teeth",
          image:
            "https://images.unsplash.com/photo-1598256989800-fe5f95da9787?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
          icon: "https://img.icons8.com/fluency/96/tooth.png",
        },
        {
          id: "veneers",
          title: "Veneers",
          description:
            "Thin porcelain shells bonded to front teeth to improve appearance",
          image:
            "https://images.unsplash.com/photo-1609840114035-3c981b782dfe?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
          icon: "https://img.icons8.com/fluency/96/tooth.png",
        },
      ],
    },
    {
      id: "perio",
      name: "Periodontics",
      icon: "https://img.icons8.com/fluency/96/tooth.png",
      image: Periodontics,
      description:
        "Treatment of gum diseases and conditions affecting the supporting structures",
      treatments: [
        {
          id: "root-planing",
          title: "Root Planing",
          description:
            "Deep cleaning below the gumline to treat periodontal disease",
          image:
            "https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
          icon: "https://img.icons8.com/fluency/96/tooth.png",
        },
        {
          id: "flap-surgery",
          title: "Flap Surgery",
          description:
            "Surgical procedure to reduce pocket depths and restore gum health",
          image:
            "https://images.unsplash.com/photo-1600170311833-c2cf5280ce49?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
          icon: "https://img.icons8.com/fluency/96/tooth.png",
        },
      ],
    },
    {
      id: "omfs",
      name: "Oral & Maxillofacial Surgery",
      icon: "https://img.icons8.com/fluency/96/tooth.png",
      image: OralMaxillofacialSurgery,
      description:
        "Surgical procedures involving the mouth, jaw, and facial structures",
      treatments: [
        {
          id: "extraction",
          title: "Extraction",
          description:
            "Removal of teeth that cannot be saved or are causing problems",
          image:
            "https://images.unsplash.com/photo-1600170311833-c2cf5280ce49?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
          icon: "https://img.icons8.com/fluency/96/tooth.png",
        },
        {
          id: "impaction",
          title: "Impaction",
          description:
            "Surgical removal of impacted teeth that cannot erupt normally",
          image:
            "https://images.unsplash.com/photo-1468493858157-0da44aaf1d13?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
          icon: "https://img.icons8.com/fluency/96/tooth.png",
        },
      ],
    },
    {
      id: "pedo",
      name: "Pediatric Dentistry",
      icon: "https://img.icons8.com/fluency/96/tooth.png",
      image: PediatricDentistry,
      description:
        "Specialized dental care for children from infancy through adolescence",
      treatments: [
        {
          id: "pulpectomy",
          title: "Pulpectomy",
          description:
            "Root canal treatment for primary teeth to save them from extraction",
          image:
            "https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
          icon: "https://img.icons8.com/fluency/96/tooth.png",
        },
        {
          id: "pedo-extraction",
          title: "Extraction",
          description: "Gentle removal of primary teeth when necessary",
          image:
            "https://images.unsplash.com/photo-1600170311833-c2cf5280ce49?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
          icon: "https://img.icons8.com/fluency/96/tooth.png",
        },
      ],
    },
    {
      id: "ortho",
      name: "Orthodontics",
      icon: "https://img.icons8.com/fluency/96/tooth.png",
      image: Orthodontics,
      description:
        "Correction of teeth and jaw alignment for improved function and aesthetics",
      treatments: [
        {
          id: "braces",
          title: "Braces",
          description:
            "Traditional metal braces to straighten teeth and correct bite issues",
          image:
            "https://images.unsplash.com/photo-1598256989800-fe5f95da9787?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
          icon: "https://img.icons8.com/fluency/96/tooth.png",
        },
        {
          id: "aligners",
          title: "Clear Aligners",
          description: "Invisible aligners for discreet teeth straightening",
          image:
            "https://images.unsplash.com/photo-1609840114035-3c981b782dfe?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
          icon: "https://img.icons8.com/fluency/96/tooth.png",
        },
      ],
    },
    {
      id: "implants",
      name: "Dental Implants",
      icon: "https://img.icons8.com/fluency/96/tooth.png",
      image: DentalImplants,
      description:
        "Permanent tooth replacement solutions that look and function like natural teeth",
      treatments: [
        {
          id: "single-implant",
          title: "Single Tooth Implant",
          description:
            "Titanium post surgically placed to replace a single missing tooth",
          image:
            "https://images.unsplash.com/photo-1468493858157-0da44aaf1d13?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
          icon: "https://img.icons8.com/fluency/96/tooth.png",
        },
        {
          id: "full-arch",
          title: "Full Arch Implants",
          description:
            "Complete replacement of all teeth in an arch with implant-supported prosthesis",
          image:
            "https://images.unsplash.com/photo-1606811856475-5e6fcdc6e509?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
          icon: "https://img.icons8.com/fluency/96/tooth.png",
        },
      ],
    },
  ];

  // Technology features
  const technologies = [
    {
      id: "tech1",
      title: "3D Imaging & Printing",
      description:
        "Create precise dental restorations and surgical guides with cutting-edge 3D technology",
      icon: "https://img.icons8.com/fluency/96/3d-printer.png",
    },
    {
      id: "tech2",
      title: "AI-Assisted Diagnosis",
      description:
        "Early detection of dental conditions with artificial intelligence algorithms",
      icon: "https://img.icons8.com/fluency/96/artificial-intelligence.png",
    },
    {
      id: "tech3",
      title: "VR Pain Management",
      description:
        "Virtual reality distraction therapy to reduce anxiety and discomfort during procedures",
      icon: "https://img.icons8.com/fluency/96/virtual-reality.png",
    },
    {
      id: "tech4",
      title: "Digital Smile Design",
      description:
        "Visualize your smile transformation before treatment begins",
      icon: "https://img.icons8.com/fluency/96/design.png",
    },
  ];

const teamMembers = [
  {
    id: 1,
    name: "Dr. Chayanika",
    role: "Cosmetic Dentist",
    bio: "As a dedicated and compassionate dentist, I prioritize delivering exceptional patient care and creating a comfortable, stress-free environment. With 4 years of experience and a passion for transforming smiles through general and cosmetic dentistry, I strive to provide personalized treatment plans that meet each patient's unique needs and goals.",
    image: chayadoc,
  },
  {
    id: 2,
    name: "Dr. Yuvapriya P",
    role: "BDS, Fellowship in Medical Cosmetology ",
    bio: "Enthusiastic and patient-centered dentist with a strong commitment to providing exceptional oral care and enhancing patient comfort. Skilled in a wide range of dental procedures including root canal treatments, extractions, restorations, implant surgeries, and orthodontic procedures. Specialized in medical cosmetology and trichology with extensive training in advanced dental techniques. Dedicated to educating patients on preventive care and utilizing cutting-edge skills to enhance patient well-being.",
    image: yuvapriya,
  },
];



  const testimonials = [
    {
      id: 1,
      name: "Priya R.",
      treatment: "Dental Scaling & Polishing",
      quote:
        "I booked my first dental cleaning here and was amazed at the results. In just one session, my teeth felt so much cleaner and my gums looked healthier. The ₹ scaling and polishing offer is a steal. Super hygienic place and really friendly staff!.",
      image:
        "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80",
      rating: 5,
    },
    {
      id: 2,
      name: "Anand V.",
      treatment: "Root Canal Therapy",
      quote:
        "Never thought a root canal could be this smooth. Absolutely no pain, and the process was quicker than I expected. The team kept me comfortable throughout. Great experience at H‑Cura Dental!.",
      image:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80",
      rating: 5,
    },
    {
      id: 3,
      name: "Sneha M.",
      treatment: "Braces (Orthodontics) ",
      quote:
        "Just got my braces off and I LOVE my new smile! The entire treatment was well-organized and hassle-free. The team at H‑Cura Dental was always there to support me through every adjustment. Best dental experience ever!",
      image:
        "https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80",
      rating: 5,
    },
    {
      id: 4,
      name: "Ravi Kumar",
      treatment: " Dental Implants",
      quote:
        "I got a dental implant done after losing a tooth. The entire procedure was painless, and it feels just like a natural tooth. Very happy with the follow-up and how clean the clinic is. Thank you, H‑Cura!.",
      image:
        "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80",
      rating: 5,
    },
    {
      id: 5,
      name: "Neha S.",
      treatment: "Teeth Whitening",
      quote:
        "I got teeth whitening done before my engagement and the results were instant. My smile looked camera-ready and there was no sensitivity at all. Loved the calm vibe of the clinic too..",
      image:
        "https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80",
      rating: 5,
    },
    {
      id: 6,
      name: "Meena Iyer",
      treatment: "Tooth-Colored Fillings",
      quote:
        "Had a cavity filled with a tooth-colored filling—it blends in perfectly! The process was quick, painless, and professional. H‑Cura Dental is now my go-to place for all dental needs.",
      image:
        "https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80",
      rating: 5,
    },
    {
      id: 7,
      name: "Arunesh P",
      treatment: "Gum Therapy (Periodontal Care) ",
      quote:
        "I had bleeding gums and plaque buildup, and the team at H‑Cura Dental treated it with deep cleaning and follow-ups. My gums feel much healthier now. Highly recommended for gum care!",
      image:
        "https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80",
      rating: 5,
    },
    {
      id: 8,
      name: "Lavanya G.",
      treatment: "Crown & Bridge",
      quote:
        "I received a dental crown for a broken tooth. The fitting was accurate, and the crown feels very natural. The color match is perfect, and I love how clean and well-managed the clinic is.",
      image:
        "https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80",
      rating: 5,
    },
  ];

  // Auto-scroll for horizontal testimonial cards
  useEffect(() => {
    const container = testimonialScrollRef.current;
    if (!container) return;

    let autoScroll;
    const cardWidth = 370; 
    const scrollStep = cardWidth;

    function startAutoScroll() {
      autoScroll = setInterval(() => {
        if (!container) return;
        if (
          container.scrollLeft + container.offsetWidth >=
          container.scrollWidth - 5
        ) {
          container.scrollTo({ left: 0, behavior: "smooth" });
        } else {
          container.scrollBy({ left: scrollStep, behavior: "smooth" });
        }
      }, 3000);
    }
    startAutoScroll();

    const pause = () => clearInterval(autoScroll);
    const resume = () => startAutoScroll();

    container.addEventListener("mouseenter", pause);
    container.addEventListener("mouseleave", resume);

    return () => {
      clearInterval(autoScroll);
      container.removeEventListener("mouseenter", pause);
      container.removeEventListener("mouseleave", resume);
    };
  }, []);

  // Corrected useEffect for testimonial strip functionality
  useEffect(() => {
    const dots = document.querySelectorAll('.dental-testimonial-dots .dental-dot');
    const quotes = document.querySelectorAll('.dental-testimonial-quote');
    
    // IMPORTANT: Check if elements exist before proceeding.
    if (dots.length === 0 || quotes.length === 0) {
      return;
    }

    // Function to update active slide in DOM and state
    const updateActiveSlideInDOM = (indexToActivate) => {
      if (indexToActivate < 0 || indexToActivate >= quotes.length) {
        return;
      }

      dots.forEach(d => { if (d) d.classList.remove('active'); });
      quotes.forEach(q => { if (q) q.classList.remove('active'); });

      if (dots[indexToActivate]) {
        dots[indexToActivate].classList.add('active');
      }
      if (quotes[indexToActivate]) {
        quotes[indexToActivate].classList.add('active');
      }
      setActiveTestimonial(indexToActivate); // Keep React state in sync
    };

    // Initialize the active slide based on current state
    updateActiveSlideInDOM(activeTestimonial);

    // Add click event listeners to dots
    const dotClickHandlers = [];
    dots.forEach((dot, index) => {
      const handler = () => updateActiveSlideInDOM(index);
      if (dot) {
        dot.addEventListener('click', handler);
        dotClickHandlers.push({ dot, handler });
      }
    });
    
    // Auto-slide functionality
    let currentSlide = activeTestimonial;
    const slideInterval = setInterval(() => {
      currentSlide = (currentSlide + 1) % quotes.length;
      updateActiveSlideInDOM(currentSlide);
    }, 4000); 
    
    return () => {
      clearInterval(slideInterval);
      // Clean up event listeners
      dotClickHandlers.forEach(({ dot, handler }) => {
        if (dot) {
          dot.removeEventListener('click', handler);
        }
      });
    };
  }, [testimonialQuotes.length, activeTestimonial]); // Re-run if testimonial data or active slide changes


  return (
    <div className="dental-page">
      {/* Hero Section with Video Background */}
      <section
        className="dental-hero"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1629909613654-28e377c37b09?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=80')`,
        }}
      >
        <div className="dental-hero-overlay"></div>
        <div className="dental-hero-content">
          <div className="dental-hero-logo">
            <div className="dental-logo-icon">
              <img
                src="https://img.icons8.com/fluency/96/tooth.png"
                alt="Tooth icon"
              />
            </div>
            <h1 className="dental-hero-title">H-CURA DENTAL</h1>
          </div>
          <h2 className="dental-hero-subtitle">
            Dental Clinic – India's Trusted Dental Care
          </h2>
          <p className="dental-hero-description">
            Bringing Advanced, Affordable, and Personalised Dental Care to Every
            Corner of India
          </p>
          <div className="dental-hero-buttons">
            <a href="#book" className="dental-primary-button">
              Book Consultation
            </a>
            <a href="#treatments" className="dental-secondary-button">
              Explore Treatments
            </a>
          </div>
          <div className="dental-hero-features">
            <div className="dental-hero-feature">
              <img
                src="https://img.icons8.com/fluency/48/certificate.png"
                alt="Certificate"
              />
              <span>Award-Winning Care</span>
            </div>

            <div className="dental-hero-feature">
              <img
                src="https://img.icons8.com/fluency/48/innovation.png"
                alt="Innovation"
              />
              <span>Latest Technology</span>
            </div>
          </div>
        </div>
        <div className="dental-scroll-indicator">
          <div className="dental-mouse">
            <div className="dental-wheel"></div>
          </div>
          <div className="dental-scroll-text">Scroll to explore</div>
        </div>
      </section>

      {/* About Section with Parallax */}
      <section id="about" className="dental-about">
        <div className="dental-parallax-bg"></div>
        <div className="dental-container">
          <div className="dental-about-content">
            <div
              className={`dental-section-header animate-on-scroll ${
                isAnimating["about-header"] ? "animate" : ""
              }`}
              id="about-header"
            >
              <span className="dental-section-subtitle">About H-CURA</span>
              <h2 className="dental-section-title">
                Redefining Dental Excellence
              </h2>
              <div className="dental-title-line"></div>
            </div>
            <div className="dental-about-grid">
              <div className="dental-about-image">
                <img
                  src="https://images.unsplash.com/photo-1588776814601-a454a8e3a940?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
                  alt="Modern dental clinic"
                />
                <div className="dental-about-experience">
                  <span className="dental-experience-number">3+</span>
                  <span className="dental-experience-text">
                    Years of Excellence
                  </span>
                </div>
              </div>
              <div
                className={`dental-about-text animate-on-scroll ${
                  isAnimating["about-text"] ? "animate" : ""
                }`}
                id="about-text"
              >
                <p>
                  Welcome to Hcura Dental Clinic, one of India’s leading and
                  fastest-growing dental care providers. We are redefining how
                  dental care is delivered by combining compassionate service,
                  cutting-edge technology, and a network of top-tier dental
                  professionals across multiple locations.
                </p>
                <p>
                  Whether you're in a bustling metro like Bangalore, Chennai, or
                  a developing urban suburb, Hcura Dental Clinic ensures
                  consistent, high-quality care designed to suit your local
                  needs.
                </p>
                <div className="dental-about-stats">
                  <div className="dental-stat">
                    <span className="dental-stat-numbers">5,000+</span>
                    <span className="dental-stat-text">Smiles Transformed</span>
                  </div>
                  <div className="dental-stat">
                    <span className="dental-stat-numbers">98%</span>
                    <span className="dental-stat-text">
                      Patient Satisfaction
                    </span>
                  </div>
                  <div className="dental-stat">
                    <span className="dental-stat-numbers">15</span>
                    <span className="dental-stat-text">Specialist Doctors</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section - Enhanced with testimonial strip */}
      <section id="why-choose-section" className="dental-why-choose-enhanced">
        <div className="dental-curved-background">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path fill="#ffffff" fillOpacity="1" d="M0,160L48,138.7C96,117,192,75,288,74.7C384,75,480,117,576,160C672,203,768,245,864,229.3C960,213,1056,139,1152,117.3C1248,96,1344,128,1392,144L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
          </svg>
        </div>

        <div className="dental-content-wrapper">
          <div className="dental-section-header-enhanced">
            <span className="dental-section-subtitle-enhanced">Best Dental Care in India</span>
            <h2 className="dental-section-title-enhanced">
              Why Hcura Dental Clinic is the Choice of Thousands Across India
            </h2>
            <div className="dental-decorative-line">
              <span className="dental-decorative-icon">
                <img src="https://img.icons8.com/fluency/48/tooth.png" alt="Tooth icon" />
              </span>
            </div>
            <p className="dental-section-description-enhanced">
              Choose H-Cura because we care about your dental health and happiness. Our experienced dentists use the latest technology to give you safe, effective treatments. We have convenient locations across India, making it easy for you to get quality dental care.
            </p>
          </div>

          <div className="dental-awards-banner">
            <div className="dental-award">
              <img src="https://img.icons8.com/fluency/48/trophy.png" alt="Award" className="dental-award-icon" />
              <span>Best Dental Clinic India 2024</span>
            </div>
            <div className="dental-award">
              <img src="https://img.icons8.com/fluency/48/certificate.png" alt="Certificate" className="dental-award-icon" />
              <span>ISO Certified</span>
            </div>
            <div className="dental-award">
              <img src="https://img.icons8.com/fluency/48/award.png" alt="Award" className="dental-award-icon" />
              <span>Top Dental Provider</span>
            </div>
          </div>

          <div className="dental-features-grid-enhanced">
            <div className="dental-feature-card-enhanced">
              <div className="dental-feature-header">
                <div className="dental-icon-container">
<img src="https://img.icons8.com/fluency/48/marker.png" alt="Multi-city" />
                  <div className="dental-icon-glow"></div>
                </div>
                <span className="dental-feature-highlight">Nationwide</span>
              </div>
              <h3>Multicity Presence With Consistent Quality</h3>
              <p>
                We proudly operate across multiple cities, bringing the same
                level of advanced care, skilled professionals, and ethical
                treatment to every location.
              </p>
              <div className="dental-feature-footer">
                <div className="dental-feature-dots">
                  <span className="dental-dot"></span>
                  <span className="dental-dot"></span>
                  <span className="dental-dot"></span>
                </div>
              </div>
            </div>

            <div className="dental-feature-card-enhanced">
              <div className="dental-feature-header">
                <div className="dental-icon-container">
<img src="https://img.icons8.com/fluency/48/stethoscope.png" alt="Experts" />
                  <div className="dental-icon-glow"></div>
                </div>
                <span className="dental-feature-highlight">MDS Qualified</span>
              </div>
              <h3>India's Top Dental Experts Under One Brand</h3>
              <p>
                Our team consists of MDS-qualified dentists experienced in
                general, cosmetic, pediatric, and surgical dental care.
              </p>
              <div className="dental-feature-footer">
                <div className="dental-feature-dots">
                  <span className="dental-dot"></span>
                  <span className="dental-dot"></span>
                  <span className="dental-dot"></span>
                </div>
              </div>
            </div>

            <div className="dental-feature-card-enhanced">
              <div className="dental-feature-header">
                <div className="dental-icon-container">
                  <img src="https://img.icons8.com/fluency/48/heart-with-pulse.png" alt="Personalized" />
                  <div className="dental-icon-glow"></div>
                </div>
                <span className="dental-feature-highlight">Community Care</span>
              </div>
              <h3>Personalised Care Tailored to Local Communities</h3>
              <p>
                Whether it's a metro-city high-rise or a growing township, our
                approach is rooted in understanding and serving the unique
                dental health needs of the community we're in.
              </p>
              <div className="dental-feature-footer">
                <div className="dental-feature-dots">
                  <span className="dental-dot"></span>
                  <span className="dental-dot"></span>
                  <span className="dental-dot"></span>
                </div>
              </div>
            </div>

            <div className="dental-feature-card-enhanced">
              <div className="dental-feature-header">
                <div className="dental-icon-container">
                  <img src="https://img.icons8.com/fluency/48/innovation.png" alt="Modern" />
                  <div className="dental-icon-glow"></div>
                </div>
                <span className="dental-feature-highlight">Latest Tech</span>
              </div>
              <h3>Pain-Free, Modern Dentistry</h3>
              <p>
                Our clinics are equipped with digital X-rays, laser tools,
                invisible aligner technology, and other innovations for safer,
                faster, and more comfortable procedures.
              </p>
              <div className="dental-feature-footer">
                <div className="dental-feature-dots">
                  <span className="dental-dot"></span>
                  <span className="dental-dot"></span>
                  <span className="dental-dot"></span>
                </div>
              </div>
            </div>
          </div>


<div className="dental-testimonial-strip">
  <div className="dental-testimonial-background"></div>
  <div className="dental-testimonial-content">
    <div className="dental-quote-marks">"</div>
    <div className="dental-testimonial-slider">
      {testimonialQuotes.map((quote, index) => (
        <div className="dental-testimonial-quote" key={index}><p>{quote}</p></div>
      ))}
    </div>
  </div>
</div>


          <div className="dental-stats-container-enhanced">
            <div className="dental-stat-box-enhanced">
              <div className="dental-stat-number-enhanced">3+</div>
              <div className="dental-stat-label-enhanced">Years of Excellence</div>
            </div>
            <div className="dental-stat-box-enhanced">
              <div className="dental-stat-number-enhanced">15+</div>
              <div className="dental-stat-label-enhanced">Medical Experts</div>
            </div>
            <div className="dental-stat-box-enhanced">
              <div className="dental-stat-number-enhanced">5k+</div>
              <div className="dental-stat-label-enhanced">Happy Patients</div>
            </div>
            <div className="dental-stat-box-enhanced">
              <div className="dental-stat-number-enhanced">98%</div>
              <div className="dental-stat-label-enhanced">Success Rate</div>
            </div>
          </div>

          <div className="dental-cta-container-enhanced">
            <h3>Experience the H-Cura Dental Difference</h3>
            <p>Join thousands of satisfied patients who have transformed their lives with our expert dental care across India.</p>
            <a href="#book" className="dental-cta-button-enhanced">Book Your Consultation</a>
          </div>
        </div>

        <div className="dental-curved-background-bottom">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path fill="#ffffff" fillOpacity="1" d="M0,160L48,181.3C96,203,192,245,288,229.3C384,213,480,139,576,128C672,117,768,171,864,197.3C960,224,1056,224,1152,213.3C1248,203,1344,181,1392,170.7L1440,160L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"></path>
          </svg>
        </div>
      </section>

      {/* Treatments Section with Filter Tabs */}
      <section id="treatments" className="dental-treatments">
        <div className="dental-container">
          <div
            className={`dental-section-header animate-on-scroll ${
              isAnimating["treatments-header"] ? "animate" : ""
            }`}
            id="treatments-header"
          >
            <span className="dental-section-subtitle">Our Services</span>
            <h2 className="dental-section-title">Advanced Dental Treatments</h2>
            <div className="dental-title-line"></div>
          </div>

          {/* Main Category Tabs */}
          <div className="dental-tabs">
            <button
              className={`dental-tab ${
                activeTab === "all" && !expandedCategory ? "active" : ""
              }`}
              onClick={() => handleTabClick("all")}
            >
              All Treatments
            </button>
            <button
              className={`dental-tab ${
                activeTab === "general" || expandedCategory === "general"
                  ? "active"
                  : ""
              }`}
              onClick={() => handleTabClick("general")}
            >
              General Dentistry
            </button>
            <button
              className={`dental-tab ${
                activeTab === "endodontics" ||
                expandedCategory === "endodontics"
                  ? "active"
                  : ""
              }`}
              onClick={() => handleTabClick("endodontics")}
            >
              Endodontics
            </button>
            <button
              className={`dental-tab ${
                activeTab === "prostho" || expandedCategory === "prostho"
                  ? "active"
                  : ""
              }`}
              onClick={() => handleTabClick("prostho")}
            >
              Prosthodontics
            </button>
            <button
              className={`dental-tab ${
                activeTab === "perio" || expandedCategory === "perio"
                  ? "active"
                  : ""
              }`}
              onClick={() => handleTabClick("perio")}
            >
              Periodontics
            </button>
            <button
              className={`dental-tab ${
                activeTab === "omfs" || expandedCategory === "omfs"
                  ? "active"
                  : ""
              }`}
              onClick={() => handleTabClick("omfs")}
            >
              OMFS
            </button>
            <button
              className={`dental-tab ${
                activeTab === "pedo" || expandedCategory === "pedo"
                  ? "active"
                  : ""
              }`}
              onClick={() => handleTabClick("pedo")}
            >
              Pediatric
            </button>
            <button
              className={`dental-tab ${
                activeTab === "ortho" || expandedCategory === "ortho"
                  ? "active"
                  : ""
              }`}
              onClick={() => handleTabClick("ortho")}
            >
              Orthodontics
            </button>
            <button
              className={`dental-tab ${
                activeTab === "implants" || expandedCategory === "implants"
                  ? "active"
                  : ""
              }`}
              onClick={() => handleTabClick("implants")}
            >
              Implants
            </button>
          </div>

          {/* Main Categories Grid - Shows when "All Treatments" is selected and no category is expanded */}
          {activeTab === "all" && !expandedCategory && (
            <div
              className={`dental-categories-grid animate-on-scroll ${
                isAnimating["categories-grid"] ? "animate" : ""
              }`}
              id="categories-grid"
            >
              {categories.map((category) => (
                <div
                  key={category.id}
                  className="dental-category-card"
                  onClick={() => handleCategoryClick(category.id)}
                >
                  <div className="dental-category-image-container">
                    <div
                      className="dental-category-image"
                      style={{ backgroundImage: `url(${category.image})` }}
                    >
                      <div className="dental-category-overlay">
                        <img
                          src={category.icon}
                          alt={category.name}
                          className="dental-category-icon"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="dental-category-content">
                    <h3 className="dental-category-title">{category.name}</h3>
                    <p className="dental-category-description">
                      {category.description}
                    </p>
                    <div className="dental-category-link">
                      <span>View Treatments</span>
                      <span className="dental-arrow">→</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Sub-treatments Grid - Shows when a specific tab is selected or when a category is expanded */}
          {(activeTab !== "all" || expandedCategory) && (
            <>
              {/* Category Title and Back Button */}
              <div className="dental-category-header">
                <h3 className="dental-category-main-title">
                  {expandedCategory
                    ? categories.find((cat) => cat.id === expandedCategory)
                        ?.name
                    : categories.find((cat) => cat.id === activeTab)?.name}{" "}
                  Treatments
                </h3>
                <button
                  className="dental-back-button"
                  onClick={() =>
                    activeTab === "all"
                      ? setExpandedCategory(null)
                      : handleTabClick("all")
                  }
                >
                  <span className="dental-back-arrow">←</span> Back to{" "}
                  {activeTab === "all" ? "All Treatments" : "Main Categories"}
                </button>
              </div>

              {/* Sub-treatments Grid */}
              <div
                className={`dental-treatments-grid animate-on-scroll ${
                  isAnimating["treatments-grid"] ? "animate" : ""
                }`}
                id="treatments-grid"
              >
                {/* Filter treatments based on the active tab or expanded category */}
                {(activeTab !== "all"
                  ? categories.find((cat) => cat.id === activeTab)?.treatments
                  : categories.find((cat) => cat.id === expandedCategory)
                      ?.treatments
                )?.map((treatment) => (
                  <div
                    key={treatment.id}
                    className="dental-treatment-card"
                  >
                    <div className="dental-treatment-image-container">
                      <div
                        className="dental-treatment-image"
                        style={{ backgroundImage: `url(${treatment.image})` }}
                      >
                        <div className="dental-treatment-overlay">
                          <img
                            src={treatment.icon}
                            alt={treatment.title}
                            className="dental-treatment-icon"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="dental-treatment-content">
                      <h3 className="dental-treatment-title">
                        {treatment.title}
                      </h3>
                      <p className="dental-treatment-description">
                        {treatment.description}
                      </p>
                      <div className="dental-treatment-link">
                        <span>Learn More</span>
                        <span className="dental-arrow">→</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </section>

      {/* Technology Showcase */}
      {/* Technology Section - Enhanced Modern Design */}
{/* Technology Section - Futuristic Glass Design */}
{/* Technology Section - Elegant Minimalist Design */}
{/* H-Cura's Advanced Toolkit: Precision, Comfort, Excellence Section */}
{/* H-Cura's Advanced Toolkit: The Future of Your Smile Section */}
<section id="advanced-toolkit" className="dental-tech-showcase-dynamic">
  <div className="dental-dynamic-bg-gradient"></div>
  <div className="dental-dynamic-overlay-pattern"></div>
  
  <div className="dental-dynamic-container">
    <div className="dental-dynamic-header">
      <div className="dental-dynamic-badge">
        <span className="dental-badge-icon">🚀</span>
        <span>Pioneering Dental Innovations</span>
      </div>
      <h2 className="dental-dynamic-title">
        H-Cura's Advanced Toolkit: The Future of Your Smile
        <span className="dental-dynamic-subtitle">Precision, Comfort, and Lasting Health Powered by Technology</span>
      </h2>
      <div className="dental-dynamic-description">
        <p>Step into a new era of dental care where cutting-edge technology, superior materials, and a commitment to your comfort converge. H-Cura brings you an unparalleled dental experience, ensuring every treatment is precise, efficient, and tailored for your ultimate well-being.</p>
      </div>
    </div>

    <div className="dental-dynamic-feature-cards-grid">
      {/* Card 1: Digital Diagnostics & Imaging */}
      <div className="dental-dynamic-card dental-dynamic-card-diag">
        <div className="dental-card-icon-circle">
 <img src="https://img.icons8.com/fluency/96/3d-printer.png" alt="Digital Diagnostics" />        </div>
        <h3 className="dental-card-title">Digital Diagnostics & 3D Imaging</h3>
        <p className="dental-card-intro">Unveiling hidden details for the most accurate diagnosis and treatment planning.</p>
        <ul className="dental-card-feature-list">
          <li>**3D CBCT Scans:** Comprehensive views of your oral anatomy.</li>
          <li>**Intraoral Scanners:** Comfortable, precise digital impressions.</li>
          <li>**AI-Powered X-ray Analysis:** Early and accurate detection of issues.</li>
          <li>**Low-Radiation Digital X-rays:** Safer, instant imaging.</li>
        </ul>
        <div className="dental-card-hover-indicator"></div>
      </div>

      {/* Card 2: Advanced Treatment Modalities */}
      <div className="dental-dynamic-card dental-dynamic-card-treat">
        <div className="dental-card-icon-circle">
          <img src="https://img.icons8.com/fluency/96/artificial-intelligence.png" alt="Advanced Treatment" />
        </div>
        <h3 className="dental-card-title">Advanced Treatment Modalities</h3>
        <p className="dental-card-intro">Experience minimally invasive procedures with enhanced precision and faster recovery.</p>
        <ul className="dental-card-feature-list">
          <li>**Dental Lasers:** Painless soft tissue treatments & cavity prep.</li>
          <li>**CAD/CAM (CEREC):** Same-day, custom-fit crowns and restorations.</li>
          <li>**Operating Microscopes:** Magnified vision for intricate procedures.</li>
          <li>**Piezoelectric Surgery:** Gentle bone surgery with minimal trauma.</li>
        </ul>
        <div className="dental-card-hover-indicator"></div>
      </div>

      {/* Card 3: Superior Materials & Restorations */}
      <div className="dental-dynamic-card dental-dynamic-card-mat">
        <div className="dental-card-icon-circle">
          <img src="https://img.icons8.com/fluency/96/design.png" alt="Superior Materials" />
        </div>
        <h3 className="dental-card-title">Superior Materials & Restorations</h3>
        <p className="dental-card-intro">Crafting durable, natural-looking solutions that seamlessly blend with your smile.</p>
        <ul className="dental-card-feature-list">
          <li>**Zirconia & E-max:** High-strength, aesthetic crowns and veneers.</li>
          <li>**Biocompatible Composites:** Safe, mercury-free tooth-colored fillings.</li>
          <li>**Titanium & Zirconia Implants:** Long-lasting, stable tooth replacements.</li>
          <li>**Growth Factors (PRF/PRP):** Enhancing natural healing for faster recovery.</li>
        </ul>
        <div className="dental-card-hover-indicator"></div>
      </div>

      {/* Card 4: Patient Comfort & Safety Innovations */}
      <div className="dental-dynamic-card dental-dynamic-card-comfort">
        <div className="dental-card-icon-circle">
          <img src="https://img.icons8.com/fluency/96/virtual-reality.png" alt="Patient Comfort" />
        </div>
        <h3 className="dental-card-title">Patient Comfort & Safety Innovations</h3>
        <p className="dental-card-intro">Your peace of mind and well-being are paramount in our advanced clinic.</p>
        <ul className="dental-card-feature-list">
          <li>**Virtual Reality (VR) Immersion:** Distraction therapy for anxiety-free visits.</li>
          <li>**Nitrous Oxide Sedation:** Gentle relaxation for sensitive patients.</li>
          <li>**Advanced Sterilization:** Rigorous protocols for a pristine environment.</li>
          <li>**Ergonomic Dental Chairs:** Designed for maximum relaxation during treatments.</li>
        </ul>
        <div className="dental-card-hover-indicator"></div>
      </div>
    </div>

    <div className="dental-dynamic-key-advantages-section">
      <div className="dental-advantages-content">
        <h3>Why Our Toolkit Makes a Difference</h3>
        <p>Our integrated approach means more than just advanced machines; it means:</p>
        <div className="dental-advantages-list">
          <div className="dental-advantage-item">
            <span className="dental-item-marker">✓</span>
            <span>**Enhanced Accuracy:** Fewer errors, better outcomes.</span>
          </div>
          <div className="dental-advantage-item">
            <span className="dental-item-marker">✓</span>
            <span>**Reduced Discomfort:** Gentle procedures, faster healing.</span>
          </div>
          <div className="dental-advantage-item">
            <span className="dental-item-marker">✓</span>
            <span>**Time Efficiency:** Fewer appointments, quicker results.</span>
          </div>
          <div className="dental-advantage-item">
            <span className="dental-item-marker">✓</span>
            <span>**Lasting Results:** Durable restorations, long-term health.</span>
          </div>
          <div className="dental-advantage-item">
            <span className="dental-item-marker">✓</span>
            <span>**Complete Transparency:** Understand every step of your treatment.</span>
          </div>
        </div>
      </div>
      <div className="dental-advantages-image">
        <img src="https://images.unsplash.com/photo-1616391182219-e080b4d1043a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MXxzZWFyY2h8Nnx8ZGVudGlzdCUyMGNsaW5pY3xlbnwwfHx8fDE3NDI1NDM3NDN8MA&auto=format&fit=crop&w=800&q=80" alt="Dental Clinic Interior" />
      </div>
    </div>

    <div className="dental-dynamic-cta-final">
      <h3>Ready to Experience Advanced Dental Care?</h3>
      <p>Discover how H-Cura's cutting-edge toolkit creates a more comfortable, precise, and effective dental experience, tailored for your lasting oral health.</p>
      <button className="dental-dynamic-cta-button">
        <span>Schedule Your Personalized Consultation</span>
        <div className="dental-button-shine-effect"></div>
      </button>
    </div>
  </div>
</section>







      {/* Who We Serve Section */}
     {/* Who We Serve Section - Enhanced Modern Design */}
{/* Who We Serve Section - Elegant Minimalist Design */}
<section id="who-we-serve-section" className="dental-serve-elegant">
  <div className="dental-serve-geometric-bg">
    <div className="dental-geometric-shape dental-shape-1"></div>
    <div className="dental-geometric-shape dental-shape-2"></div>
    <div className="dental-geometric-shape dental-shape-3"></div>
  </div>
  
  <div className="dental-serve-container">
    <div className="dental-serve-header-minimal">
      <div className="dental-serve-badge-elegant">
        <span>Comprehensive Care for Every Indian</span>
      </div>
      <h2 className="dental-serve-title-sophisticated">
        Personalized Dental Excellence
        <span className="dental-serve-subtitle-refined">Tailored for Your Life Stage</span>
      </h2>
      <div className="dental-serve-description-elegant">
        <p>From toddlers taking their first steps to grandparents sharing wisdom, our specialized dental care adapts to every life stage, profession, and unique health requirement across India.</p>
      </div>
    </div>

    <div className="dental-serve-personas-grid">
      <div className="dental-persona-card dental-persona-children">
        <div className="dental-persona-image-container">
          <div className="dental-persona-gradient-overlay"></div>
          <img src="https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" alt="Children dental care" />
        </div>
        <div className="dental-persona-content">
          {/* <div className="dental-persona-icon">
            <img src="https://img.icons8.com/fluency/48/baby.png" alt="Children" />
          </div> */}
          <h3>Growing Smiles</h3>
          <p className="dental-persona-age">Ages 2-16</p>
          <p className="dental-persona-description">Gentle pediatric care, preventive treatments, and early orthodontics to ensure healthy development and positive dental experiences.</p>
          <div className="dental-persona-features">
            <span>Kid-Friendly Environment</span>
            <span>Preventive Focus</span>
            <span>Anxiety-Free Experience</span>
          </div>
        </div>
        <div className="dental-persona-hover-effect"></div>
      </div>

      <div className="dental-persona-card dental-persona-professionals">
        <div className="dental-persona-image-container">
          <div className="dental-persona-gradient-overlay"></div>
          <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" alt="Professional dental care" />
        </div>
        <div className="dental-persona-content">
          {/* <div className="dental-persona-icon">
            <img src="https://img.icons8.com/fluency/48/briefcase.png" alt="Professionals" />
          </div> */}
          <h3>Career Confidence</h3>
          <p className="dental-persona-age">Ages 18-45</p>
          <p className="dental-persona-description">Cosmetic enhancements, teeth whitening, and smile makeovers for professionals who need to look their best in competitive environments.</p>
          <div className="dental-persona-features">
            <span>Cosmetic Excellence</span>
            <span>Quick Results</span>
            <span>Flexible Scheduling</span>
          </div>
        </div>
        <div className="dental-persona-hover-effect"></div>
      </div>

      <div className="dental-persona-card dental-persona-families">
        <div className="dental-persona-image-container">
          <div className="dental-persona-gradient-overlay"></div>
          <img src="https://images.unsplash.com/photo-1511895426328-dc8714191300?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" alt="Family dental care" />
        </div>
        <div className="dental-persona-content">
          {/* <div className="dental-persona-icon">
            <img src="https://img.icons8.com/fluency/48/family-man-woman-girl-boy.png" alt="Families" />
          </div> */}
          <h3>Family Harmony</h3>
          <p className="dental-persona-age">All Ages</p>
          <p className="dental-persona-description">Comprehensive family packages, synchronized appointments, and coordinated treatment plans for busy parents managing multiple schedules.</p>
          <div className="dental-persona-features">
            <span>Family Packages</span>
            <span>Coordinated Care</span>
            <span>Convenient Timing</span>
          </div>
        </div>
        <div className="dental-persona-hover-effect"></div>
      </div>

      <div className="dental-persona-card dental-persona-special">
        <div className="dental-persona-image-container">
          <div className="dental-persona-gradient-overlay"></div>
          <img src="https://images.unsplash.com/photo-1559757148-5c350d0d3c56?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" alt="Special needs dental care" />
        </div>
        <div className="dental-persona-content">
          {/* <div className="dental-persona-icon">
            <img src="https://img.icons8.com/fluency/48/medical-heart.png" alt="Special Care" />
          </div> */}
          <h3>Specialized Care</h3>
          <p className="dental-persona-age">Medical Conditions</p>
          <p className="dental-persona-description">Safe, hygienic care for patients with diabetes, heart conditions, and other medical needs requiring specialized attention and protocols.</p>
          <div className="dental-persona-features">
            <span>Medical Protocols</span>
            <span>Safe Environment</span>
            <span>Expert Monitoring</span>
          </div>
        </div>
        <div className="dental-persona-hover-effect"></div>
      </div>
    </div>

    <div className="dental-serve-journey-map">
      <div className="dental-journey-header">
        <h3>Your Dental Journey with H-Cura</h3>
        <p>Every patient's path is unique, but our commitment to excellence remains constant</p>
      </div>
      <div className="dental-journey-steps">
        <div className="dental-journey-step">
          <div className="dental-step-number">01</div>
          <div className="dental-step-content">
            <h4>Consultation & Assessment</h4>
            <p>Comprehensive evaluation using advanced diagnostics</p>
          </div>
        </div>
        <div className="dental-journey-connector"></div>
        <div className="dental-journey-step">
          <div className="dental-step-number">02</div>
          <div className="dental-step-content">
            <h4>Personalized Treatment Plan</h4>
            <p>Customized approach based on your unique needs</p>
          </div>
        </div>
        <div className="dental-journey-connector"></div>
        <div className="dental-journey-step">
          <div className="dental-step-number">03</div>
          <div className="dental-step-content">
            <h4>Advanced Treatment</h4>
            <p>State-of-the-art procedures with comfort priority</p>
          </div>
        </div>
        <div className="dental-journey-connector"></div>
        <div className="dental-journey-step">
          <div className="dental-step-number">04</div>
          <div className="dental-step-content">
            <h4>Ongoing Care</h4>
            <p>Long-term maintenance and preventive support</p>
          </div>
        </div>
      </div>
    </div>

    <div className="dental-serve-cta-sophisticated">
      <div className="dental-cta-content-elegant">
        <h3>Your Perfect Smile Awaits</h3>
        <p>Join thousands of satisfied patients who've discovered personalized dental care that adapts to their lifestyle.</p>
        <div className="dental-cta-buttons-elegant">
          <button className="dental-btn-primary-elegant">
            <span>Start Your Journey</span>
            <div className="dental-btn-ripple"></div>
          </button>
          <button className="dental-btn-secondary-elegant">
            <span>Learn More</span>
          </button>
        </div>
      </div>
      <div className="dental-cta-stats-elegant">
        <div className="dental-stat-item-elegant">
          <span className="dental-stat-number">15,000+</span>
          <span className="dental-stat-label">Happy Families</span>
        </div>
        <div className="dental-stat-item-elegant">
          <span className="dental-stat-number">50+</span>
          <span className="dental-stat-label">Treatment Types</span>
        </div>
        <div className="dental-stat-item-elegant">
          <span className="dental-stat-number">24/7</span>
          <span className="dental-stat-label">Support Available</span>
        </div>
      </div>
    </div>
  </div>
</section>




      {/* Why Choose Us Section */}
      <section id="why-choose-us" className="dental-why-choose">
        <div className="dental-container">
          <div
            className={`dental-section-header animate-on-scroll ${
              isAnimating["why-choose-header"] ? "animate" : ""
            }`}
            id="why-choose-header"
          >
            <span className="dental-section-subtitle">Why Choose Us</span>
            <h2 className="dental-section-title">Trusted Dental Care</h2>
            <div className="dental-title-line"></div>
          </div>

          <div className="dental-row">
            {/* Left Side Box */}
            <div
              className={`dental-col dental-why-choose-left animate-on-scroll ${
                isAnimating["why-choose-content"] ? "animate" : ""
              }`}
              id="why-choose-content"
            >
              <div className="dental-why-choose-content">
                <h2>Hcura Dentists – Professionals You Can Trust</h2>
                <p>
                  We handpick qualified and compassionate dentists for every
                  city we operate in. Our doctors undergo training to maintain
                  uniform quality of care — from metro cities to tier-2 towns.
                </p>

                <h3>Patients trust us because:</h3>
                <ul className="dental-trust-points">
                  <li>We never upsell unnecessary treatments.</li>
                  <li>We educate before we treat.</li>
                  <li>We follow through with post-treatment care.</li>
                </ul>
              </div>
            </div>
            {/* Right Side Box - Before & After Gallery */}
            
            <div
              className={`dental-col dental-why-choose-right animate-on-scroll ${
                isAnimating["mini-gallery"] ? "animate" : ""
              }`}
              id="mini-gallery"
            >
              <div className="dental-mini-gallery">
                <h3 className="dental-mini-gallery-title">
                  Before & After Results
                </h3>

                <div className="before-after-gallery-slider">
                  {galleryItems.map((item, index) => (
                    <div
                      key={item.id}
                      className={`before-after-item ${
                        index === activeGalleryItem ? "active" : ""
                      }`}
                    >
                      <div className="before-after-card">
                        <div className="before-after-image-container">
                          <img
                            src={item.image}
                            alt={`Before and After - ${item.treatment}`}
                            className="before-after-image"
                          />
                        </div>
                        <div className="before-after-gallery-caption">
                          <p>{item.treatment}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="dental-gallery-nav">
                  {galleryItems.map((_, index) => (
                    <button
                      key={index}
                      className={`dental-gallery-dot ${
                        index === activeGalleryItem ? "active" : ""
                      }`}
                      onClick={() => setActiveGalleryItem(index)}
                      aria-label={`View gallery item ${index + 1}`}
                    ></button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials with Horizontal Scroll */}
    <section id="testimonials" className="dental-patient-testimonials-section">
  <div className="dental-patient-testimonials-container">
    <div
      className={`dental-patient-testimonials-header animate-on-scroll ${
        isAnimating["testimonials-header"] ? "animate" : ""
      }`}
      id="testimonials-header"
    >
      <span className="dental-patient-testimonials-subtitle">Patient Stories</span>
      <h2 className="dental-patient-testimonials-title">What Our Patients Say</h2>
      <div className="dental-patient-testimonials-title-line"></div>
    </div>

    <div
      className="dental-patient-testimonials-scroll-wrapper"
      ref={testimonialScrollRef}
    >
      {testimonials.map((testimonial, index) => (
        <div key={index} className="dental-patient-testimonial-item-wrapper">
          <div className="dental-patient-testimonial-card-box">
            <div className="dental-patient-testimonial-inner-content">
              <div className="dental-patient-testimonial-quote-badge">
                <img
                  src="https://img.icons8.com/fluency/48/quote-left.png"
                  alt="Quote"
                />
              </div>
              <p className="dental-patient-testimonial-text">{testimonial.quote}</p>
              <div className="dental-patient-testimonial-author-section">
                <div className="dental-patient-testimonial-author-info">
                  <div className="dental-patient-testimonial-author-name">
                    {testimonial.name}
                  </div>
                  <div className="dental-patient-testimonial-treatment-type">
                    {testimonial.treatment}
                  </div>
                  <div className="dental-patient-testimonial-star-rating">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <span key={i} className="dental-patient-testimonial-star-icon">
                        ★
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>



      {/* Team Section */}
      <section id="team" className="dental-team">
        <div className="dental-container">
          <div
            className={`dental-section-header animate-on-scroll ${
              isAnimating["team-header"] ? "animate" : ""
            }`}
            id="team-header"
          >
            <span className="dental-section-subtitle">Expert Specialists</span>
            <h2 className="dental-section-title">Meet Our Doctors</h2>
            <div className="dental-title-line"></div>
          </div>

          <div
            className={`dental-team-grid animate-on-scroll ${
              isAnimating["team-grid"] ? "animate" : ""
            }`}
            id="team-grid"
          >
            {teamMembers.map((member) => (
              <div key={member.id} className="dental-team-member">
                <div className="dental-member-image">
                  <img src={member.image} alt={member.name} />
                </div>
                <div className="dental-member-info">
                  <h3 className="dental-member-name">{member.name}</h3>
                  <p className="dental-member-role">{member.role}</p>
                  <p className="dental-member-bio">{member.bio}</p>
                  <div className="dental-member-social"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Booking Section */}
      <section id="book" className="dental-booking">
        <div className="dental-booking-bg"></div>
        <div className="dental-container">
          <div
            className={`dental-section-header animate-on-scroll ${
              isAnimating["booking-header"] ? "animate" : ""
            }`}
            id="booking-header"
          >
            <span className="dental-section-subtitle">Schedule Your Visit</span>
            <h2 className="dental-section-title">Book Your Consultation</h2>
            <div className="dental-title-line"></div>
          </div>

          <div
            className={`dental-booking-container animate-on-scroll ${
              isAnimating["booking-container"] ? "animate" : ""
            }`}
            id="booking-container"
          >
            <div className="dental-booking-info">
              <div className="dental-booking-text">
                <p>
                  Take the first step towards your perfect smile. Our team of
                  specialists is ready to create a personalized treatment plan
                  that meets your unique needs and goals.
                </p>
                <div className="dental-booking-features">
                  <div className="dental-booking-feature">
                    <img
                      src="https://img.icons8.com/fluency/48/credit-card-front.png"
                      alt="Payment"
                    />
                    <span>EMI Options</span>
                  </div>
                </div>
                <div className="dental-contact-info">
                  <div className="dental-contact-item">
                    <img
                      src="https://img.icons8.com/fluency/48/phone.png"
                      alt="Phone"
                    />
                    <div className="dental-contact-details">
                      <h4>Call Us</h4>
                      <p>+91 8870001377</p>
                    </div>
                  </div>
                  <div className="dental-contact-item">
                    <img
                      src="https://img.icons8.com/fluency/48/new-post.png"
                      alt="Email"
                    />
                    <div className="dental-contact-details">
                      <h4>Email Us</h4>
                      <p>admin@h-cura.com</p>
                    </div>
                  </div>
                  <div className="dental-contact-item">
                    <img
                      src="https://img.icons8.com/fluency/48/marker.png"
                      alt="Location"
                    />
                    <div className="dental-contact-details">
                      <h4>Visit Us</h4>
                      <p>
                        No:779&780 3rd Floor, Sai Towers Building, South, E End
                        Main Rd, Opposite to Metro Pillar No 92, Corporation
                        Colony, Jaya Nagara 9th Block, Jaya Nagar, Bengaluru,
                        Karnataka
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

           <div className="jayanagar-dental-booking-form">
  {formSuccess && (
    <div className="form-success-message" style={{
      backgroundColor: "#d4edda",
      color: "#155724",
      padding: "12px",
      marginBottom: "20px",
      borderRadius: "4px",
      border: "1px solid #c3e6cb"
    }}>
      Thank you! Your appointment request has been submitted successfully. We'll contact you shortly.
    </div>
  )}
  {formError && (
    <div className="form-error-message" style={{
      backgroundColor: "#f8d7da",
      color: "#721c24",
      padding: "12px",
      marginBottom: "20px",
      borderRadius: "4px",
      border: "1px solid #f5c6cb"
    }}>
      {formError}
    </div>
  )}
  <form onSubmit={handleFormSubmit}>
    <div className="jayanagar-dental-form-group">
      <label htmlFor="name">Full Name</label>
      <input
        type="text"
        id="name"
        name="name"
        placeholder="Enter your full name"
        value={formData.name}
        onChange={handleInputChange}
        required
      />
    </div>

    <div className="jayanagar-dental-form-row">
      <div className="jayanagar-dental-form-group">
        <label htmlFor="email">Email Address</label>
        <input
          type="email"
          id="email"
          name="email"
          placeholder="Enter your email"
          value={formData.email}
          onChange={handleInputChange}
          required
        />
      </div>
      <div className="jayanagar-dental-form-group">
        <label htmlFor="phone">Phone Number</label>
        <input
          type="tel"
          id="phone"
          name="phone"
          placeholder="Enter your phone number"
          value={formData.phone}
          onChange={handleInputChange}
          required
        />
      </div>
    </div>

    <div className="jayanagar-dental-form-group">
      <label htmlFor="service">Service Interested In</label>
      <select 
        id="service" 
        name="service" 
        value={formData.service}
        onChange={handleInputChange}
        required
      >
        <option value="">Select Service</option>
        {categories.map((category) => (
          <option key={category.id} value={category.name}>
            {category.name}
          </option>
        ))}
      </select>
    </div>

    <div className="jayanagar-dental-form-group">
      <label htmlFor="message">Additional Information</label>
      <textarea
        id="message"
        name="message"
        placeholder="Tell us more about your dental needs"
        rows="3"
        value={formData.message}
        onChange={handleInputChange}
      ></textarea>
    </div>

    <button
      type="submit"
      className="jayanagar-dental-submit-button"
      disabled={formSubmitting}
      style={{
        opacity: formSubmitting ? 0.7 : 1,
        cursor: formSubmitting ? "not-allowed" : "pointer"
      }}
    >
      {formSubmitting ? "Submitting..." : "Book Appointment"}
    </button>
  </form>
</div>

          </div>
        </div>
      </section>
      <section id="our-clinics" className="dental-clinics">
        <div className="dental-container">
          <div
            className={`dental-section-header animate-on-scroll ${
              isAnimating["clinics-header"] ? "animate" : ""
            }`}
            id="clinics-header"
          >
            <span className="dental-section-subtitle">
              Explore Our Locations
            </span>
            <h2 className="dental-section-title">Find Your Nearest Clinic</h2>
            <div className="dental-title-line"></div>
            <p className="dental-clinics-intro">
              Click on a location to discover our specialized services and
              facilities
            </p>
          </div>

          <div
            className={`dental-clinics-interactive animate-on-scroll ${
              isAnimating["clinics-grid"] ? "animate" : ""
            }`}
            id="clinics-grid"
          >
            <div
              className="dental-clinic-card-3d"
              onClick={() => (window.location.href = "/dental-treatment-in-bangalore/")}
            >
              <div className="dental-clinic-card-inner">
                <div className="dental-clinic-image-container">
                  <div
                    className="dental-clinic-image"
                    style={{
                      backgroundImage: `url('https://images.unsplash.com/photo-1606811856475-5e6fcdc6e509?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60')`,
                    }}
                  >
                    <div className="dental-clinic-overlay">
                      <div className="dental-clinic-badge">Flagship</div>
                      <img
                        src="https://img.icons8.com/fluency/96/marker.png"
                        alt="Location"
                        className="dental-clinic-icon"
                      />
                    </div>
                  </div>
                </div>
                <div className="dental-clinic-content">
                  <div className="dental-clinic-header">
                    <h3 className="dental-clinic-title">Jayanagar</h3>
                    <div className="dental-clinic-rating">
                      <span className="dental-clinic-star">★</span>
                      <span className="dental-clinic-star">★</span>
                      <span className="dental-clinic-star">★</span>
                      <span className="dental-clinic-star">★</span>
                      <span className="dental-clinic-star">★</span>
                      <span className="dental-clinic-reviews">(120+)</span>
                    </div>
                  </div>
                  <p className="dental-clinic-description">
                    Our flagship clinic with state-of-the-art facilities and
                    expert specialists.
                  </p>
                  <div className="dental-clinic-features">
                    <span className="dental-clinic-feature">Premium Care</span>
                    <span className="dental-clinic-feature">Advanced Tech</span>
                  </div>
                  <div className="dental-clinic-cta">
                    <span>View Details</span>
                    <span className="dental-clinic-arrow">→</span>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="dental-clinic-card-3d"
              onClick={() => (window.location.href = "/multispecialty-dental-clinic-in-gerugambakkam-chennai")}
            >
              <div className="dental-clinic-card-inner">
                <div className="dental-clinic-image-container">
                  <div
                    className="dental-clinic-image"
                    style={{
                      backgroundImage: `url('https://images.unsplash.com/photo-1598256989800-fe5f95da9787?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60')`,
                    }}
                  >
                    <div className="dental-clinic-overlay">
                      <div className="dental-clinic-badge">Cosmetic</div>
                      <img
                        src="https://img.icons8.com/fluency/96/marker.png"
                        alt="Location"
                        className="dental-clinic-icon"
                      />
                    </div>
                  </div>
                </div>
                <div className="dental-clinic-content">
                  <div className="dental-clinic-header">
                    <h3 className="dental-clinic-title">Girukambakkam</h3>
                    <div className="dental-clinic-rating">
                      <span className="dental-clinic-star">★</span>
                      <span className="dental-clinic-star">★</span>
                      <span className="dental-clinic-star">★</span>
                      <span className="dental-clinic-star">★</span>
                      <span className="dental-clinic-star">★</span>
                      <span className="dental-clinic-reviews">(98+)</span>
                    </div>
                  </div>
                  <p className="dental-clinic-description">
                    Modern facility specializing in cosmetic and restorative
                    treatments.
                  </p>
                  <div className="dental-clinic-features">
                    <span className="dental-clinic-feature">Smile Design</span>
                    <span className="dental-clinic-feature">Restoration</span>
                  </div>
                  <div className="dental-clinic-cta">
                    <span>View Details</span>
                    <span className="dental-clinic-arrow">→</span>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="dental-clinic-card-3d"
              onClick={() => (window.location.href = "multispecialty-dental-clinic-in-valasaravakkam-chennai")}
            >
              <div className="dental-clinic-card-inner">
                <div className="dental-clinic-image-container">
                  <div
                    className="dental-clinic-image"
                    style={{
                      backgroundImage: `url('https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60')`,
                    }}
                  >
                    <div className="dental-clinic-overlay">
                      <div className="dental-clinic-badge">Family</div>
                      <img
                        src="https://img.icons8.com/fluency/96/marker.png"
                        alt="Location"
                        className="dental-clinic-icon"
                      />
                    </div>
                  </div>
                </div>
                <div className="dental-clinic-content">
                  <div className="dental-clinic-header">
                    <h3 className="dental-clinic-title">Valasaravakam</h3>
                    <div className="dental-clinic-rating">
                      <span className="dental-clinic-star">★</span>
                      <span className="dental-clinic-star">★</span>
                      <span className="dental-clinic-star">★</span>
                      <span className="dental-clinic-star">★</span>
                      <span className="dental-clinic-star">★</span>
                      <span className="dental-clinic-reviews">(105+)</span>
                    </div>
                  </div>
                  <p className="dental-clinic-description">
                    Family-friendly clinic with specialized pediatric dental
                    care.
                  </p>
                  <div className="dental-clinic-features">
                    <span className="dental-clinic-feature">Kid-Friendly</span>
                    <span className="dental-clinic-feature">Family Care</span>
                  </div>
                  <div className="dental-clinic-cta">
                    <span>View Details</span>
                    <span className="dental-clinic-arrow">→</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <DentalOffer /> */}
    </div>
  );
};

export default Dental;
